document.addEventListener("alpine:init", () => {
    Alpine.data("ressources", () => ({
        displayFilter: "all",
        activeFormats: [],
        activeCategories: [],
        showAllCategories() {
            this.activeCategories = [];
        },
        toggleCategory(category) {
            if (this.activeCategories.includes(category)) {
                this.activeCategories = this.activeCategories.filter(
                    (_category) => _category !== category
                );
            } else {
                this.activeCategories.push(category);
            }
        },
        selectCategory(event) {
            // Mobile
            const value = event.target.value;
            if (value === "Tous") {
                this.activeCategories = [];
            } else {
                this.activeCategories = [value];
            }
        },
        isCategoryActive(category) {
            return this.activeCategories.includes(category);
        },
        shouldDisplayCategory(category) {
            if (this.activeCategories.length === 0) {
                return true;
            }
            return this.activeCategories.includes(category);
        },
        toggleFormat(format) {
            if (this.activeFormats.includes(format)) {
                this.activeFormats = this.activeFormats.filter(
                    (_format) => _format !== format
                );
            } else {
                this.activeFormats.push(format);
            }
        },
        selectFormat(event) {
            // Mobile
            const value = event.target.value;
            if (value === "Tous") {
                this.activeFormats = [];
            } else {
                this.activeFormats = ["value"];
            }
        },
        isFormatActive(format) {
            return this.activeFormats.includes(format);
        },
        shouldDisplayFormat(format) {
            if (this.activeFormats.length === 0) {
                return true;
            }
            return this.activeFormats.includes(format);
        },
        shouldDisplayAll() {
            return this.displayFilter === 'all'
        },
        shouldDisplayOwn() {
            return this.displayFilter === 'own'
        },
        shouldDisplayResource(isOwnDocument) {
            if (this.displayFilter === "own") {
                return isOwnDocument;
            }
            // Display filter is set to "all"
            return true
        },
    }));
});
